import { PlusRegularIcon } from "@elixir/icons";
import { usePackageBookingStore } from "@elixir/stores";
import {
  PACKAGE_POPUP_TYPE,
  PACKAGE_PRICING_MODEL,
  TSessionItem,
} from "@elixir/types";
import { useMemo } from "react";
import { SessionRowItemUi, TableUi } from "ui";

const SessionDetails = ({
  pricingModel,
  disabled,
}: {
  pricingModel?: PACKAGE_PRICING_MODEL;
  disabled?: boolean;
}) => {
  const packagePopupType = usePackageBookingStore(
    (state) => state.packagePopupType
  );

  const sessionList = usePackageBookingStore((state) => state.sessionList);
  const setSessionList = usePackageBookingStore(
    (state) => state.setSessionList
  );
  const setIncreaseSession = usePackageBookingStore(
    (state) => state.setIncreaseSession
  );

  const handleDeleteSession = (idx: number) => {
    const updatedSessionList = sessionList.filter((_, index) => index !== idx);
    setSessionList(updatedSessionList);
  };

  const handleChange: (idx: number, sessions: TSessionItem) => void = (
    idx,
    sessionListItem
  ) => {
    const updatedSessionList = sessionList.map((session, index) =>
      index === idx ? sessionListItem : session
    );
    setSessionList(updatedSessionList);
  };

  const headerConfig = useMemo(() => {
    const headerConfig = [
      { width: "15%", headerName: "Session Name", isRequired: true },
      { width: "15%", headerName: "Duration" }, // 30%
      packagePopupType === PACKAGE_POPUP_TYPE.CREATE_PACKAGE ||
      packagePopupType === PACKAGE_POPUP_TYPE.EDIT_PACKAGE
        ? { width: "15%", headerName: "Schedule" }
        : { width: "20%", headerName: "Session Date & Time" }, // 40%
      pricingModel === PACKAGE_PRICING_MODEL.PER_VISIT
        ? { width: "20%", headerName: "Session Price" }
        : {},
      { width: "40%", headerName: "Description (If Any)" },
      packagePopupType === PACKAGE_POPUP_TYPE.CREATE_PACKAGE ||
      packagePopupType === PACKAGE_POPUP_TYPE.EDIT_PACKAGE
        ? { width: "20%", headerName: "Sample Schedule" } // 25%
        : {},
      { width: "2%", headerName: "" },
    ];
    return headerConfig;
  }, [packagePopupType, pricingModel]);

  return (
    <div className="dr-flex dr-flex-col dr-gap-y-8">
      <div className="BodyBold">Session details</div>
      <TableUi headersConfig={headerConfig} className="">
        {sessionList.map((session, idx) => {
          return (
            <SessionRowItemUi
              packagePopupType={packagePopupType}
              sessionItem={session}
              disabled={disabled}
              key={`sessions-${idx}`}
              setDescription={(description) => {
                handleChange(idx, { ...session, description });
              }}
              schedule={session.schedule}
              setSchedule={(schedule) => {
                handleChange(idx, { ...session, schedule });
              }}
              setSessionPricing={(sessionPricing) => {
                const priceInInt = parseInt(sessionPricing);
                handleChange(idx, {
                  ...session,
                  price: isNaN(priceInInt) ? 0 : priceInInt,
                });
              }}
              setDuration={(duration) => {
                handleChange(idx, { ...session, duration });
              }}
              setName={(name) => {
                handleChange(idx, { ...session, name });
              }}
              pricingModel={pricingModel!}
              handleDeleteSession={() => handleDeleteSession(idx)}
            />
          );
        })}
      </TableUi>

      <div
        className={`${disabled ? "dr-text-darwin-neutral-600 dr-border-darwin-neutral-600 dr-cursor-not-allowed" : "dr-text-darwin-primary-primary dr-border-darwin-primary-primary"}  dr-flex dr-flex-row dr-py-5 dr-px-7 dr-gap-x-4 dr-border-1 dr-rounded-4  dr-bg-darwin-neutral-0 dr-max-w-100`}
      >
        <PlusRegularIcon className="dr-w-12 dr-h-14" />
        <button
          disabled={disabled}
          className="CalloutBold"
          onClick={disabled ? () => {} : setIncreaseSession}
        >
          Add session
        </button>
      </div>
      <div className="dr-h-200" />
    </div>
  );
};

export default SessionDetails;
